/**
 * Judge.me Cards Carousel の言語別見出し
 *
 * Judge.meのCards Carouselは、多言語ウィジェットを有効にすると見出しを
 * "Customers are saying" に統一する仕様で、カルーセルごとの英語見出しを
 * 管理画面から設定できない。そのため、ホームページ上の対象3ブロックに限って
 * 表示見出しをストアの現在言語に合わせて差し替える。
 *
 * Shopifyが出力するブロック要素のIDはテーマごとに先頭部分が変わるため、
 * 固定される末尾のJudge.meブロックIDで対象を判定している。
 * レビューのタグ・抽出条件・カード設定には触れない。
 */
(() => {
  const carouselHeadings = {
    judge_me_reviews_cards_carousel_KiyGQq: {
      ja: 'Review',
      en: 'HANAO Reviews',
    },
    judge_me_reviews_cards_carousel_workshop: {
      ja: 'Review (Workshop)',
      en: 'Workshop Reviews',
    },
    judge_me_reviews_cards_carousel_english: {
      // 日本語ページではこのセクション自体を非表示にしているが、
      // 万一表示された場合も日本語の汎用見出しには戻さない。
      ja: 'Reviews in English',
      en: 'Reviews in English',
    },
  };

  const currentLanguage = () => document.documentElement.lang.split('-')[0] || 'ja';

  const updateCarouselHeadings = () => {
    const language = currentLanguage();

    Object.entries(carouselHeadings).forEach(([blockId, headings]) => {
      const block = document.querySelector(`[id$="__${blockId}"]`);
      const title = block?.querySelector('.jdgm-cards-carousel .jdgm-title');
      const heading = headings[language] || headings.ja;

      if (title && title.textContent.trim() !== heading) {
        title.textContent = heading;
      }
    });
  };

  const observeCarouselHeadings = () => {
    updateCarouselHeadings();

    // Judge.meはカルーセルを非同期で描画するため、描画後の見出しにも適用する。
    const observer = new MutationObserver(updateCarouselHeadings);
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeCarouselHeadings, { once: true });
  } else {
    observeCarouselHeadings();
  }
})();
